import { filter, Observable, pipe, UnaryFunction } from 'rxjs';

export function filterUndefined<T>(): UnaryFunction<Observable<T | undefined>, Observable<T>> {
  return pipe(filter(it => it !== undefined));
}
